export default text => dispatch => {
    dispatch({
        type: 'TOGGLE_LOADING',
        payload: { isActive: true, text }
    })
}